export const ApiUrl = {
    ColorList: '/colorlist/',
    NewUserInfo: '/insertuser/',
    UpdateOpenAiSetting: '/updateopenaisetting/',
    UserFileList: '/userfilelist/',    
    DeleteFile: '/deletefile/',
    UpdateUserColor: '/updateusercolor/',
    UploadHeaderImage: '/uploadheaderimage/',
    GetHeaderImage: '/getheaderimage/',
    DownloadUsageData: '/downloadusagefile/',
    DownloadDocumentFile: 'downloaddocumentfile/',
    UpdateTextValue: '/updatetextvalue/',
    UpdateUserInitMessage: '/updateuserinitmessage/',
    InitChat: '/initchat/',
    ChatHeaderImage: '/chatheaderimage/',
    ChatRequest: '/chatrequest/',
    ChatErrorMessage: '/chaterrormessage/',
    Logout: '/logout/',
    IsLogin: '/islogin/',
    UploadFile: '/uploadfile/',
    UpdateConfig: '/updateconfig/',
    RegisttationUser: '/registtationuser/',
    Login: '/auth/token/',
    RefreshToken: '/auth/token/refresh/',
    ChangeUserPassword: '/changeuserpassword/',
}
type ApiUrl = typeof ApiUrl[keyof typeof ApiUrl]

export const RouterUrl = {
    Login: '/login',
    Upload: '/config',
    Main: '/chat',
    RegisttationUser: '/registtationuser',
    ResultMessage: '/resultmessage',
}
type RouterUrl = typeof RouterUrl[keyof typeof RouterUrl]